import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import Single from "./answer-area/Single";
import Multi from "./answer-area/Multi";
import MultiOpen from "./answer-area/MultiOpen";
import Video from "./answer-area/Video";
import Matrix from "./answer-area/Matrix";
import Ranked from "./answer-area/Ranked";
import Conjoint from "./answer-area/Conjoint";
import Open from "./answer-area/Open";
import MatrixMulti from "./answer-area/MatrixMulti";
import MatrixDropdown from "./answer-area/MatrixDropdown";
import NumericMulti from "./answer-area/NumericMulti";
import Numeric from "./answer-area/Numeric";
import Basket from "./answer-area/Basket";
import GMap from "./answer-area/GMap";
import Nps from "./answer-area/Nps";
import MaxDiff from "./answer-area/MaxDiff";
import Differential from "./answer-area/Differential";
import Comment from "./answer-area/Comment";
import Bpto from "./answer-area/Bpto";
import {addQuestionResponse, updateQuestionResponse} from "../../reducers/questionResponses/actions";
import {Alert, Card, CardBody, CardHeader} from "reactstrap";
import Excludings from "./Excludings";
import FileUpload from "./FileUpload";
import {getCurrentMicroTime} from "../../reducers/timeMeasuring/actions";
import CardTitle from "reactstrap/es/CardTitle";
import {FormattedMessage} from "react-intl";
import classnames from "classnames";

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validate: null,
      handledDetails: [],
      width: 0,
      height: 0
    };

    this.questionAnswerArea = React.createRef();
    this.fileUploader = React.createRef();
    this.getAnswerArea = this.getAnswerArea.bind(this);
    this.handleExcludingChanged = this.handleExcludingChanged.bind(this);
    this.handleDetailsUpdated = this.handleDetailsUpdated.bind(this);
    this.dispatchQuestionResponse = this.dispatchQuestionResponse.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.validate = this.validate.bind(this);

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.isMobile = this.isMobile.bind(this);
    this.questionResponseUpdateDebounced = _.debounce(this.questionResponseUpdateDebounced, 800);
  }

  updateWindowDimensions() {
    this.setState({width: window.innerWidth, height: window.innerHeight});
  }

  isMobile() {
    return this.state.width <= 767;
  }

  componentDidMount(){
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    const {questionResponse, question} = this.props;
    const microTime = getCurrentMicroTime(this.props.startTime);

    if(!questionResponse){
      if(question.questionResponse){
        this.props.dispatch(addQuestionResponse({
          ...question.questionResponse,
          microTime,
        }));
      }else{
        this.props.dispatch(addQuestionResponse({
          question: this.props.question.id,
          details: [],
          microTime,
        }));
      }
    }else{
      this.props.dispatch(updateQuestionResponse({
        ...questionResponse,
        microTime,
      }));
    }

    if(!_.isEmpty(question.css)){
      let head = document.head || document.getElementsByTagName('head')[0];
      let style = document.createElement('style');

      style.setAttribute('id', 'question-style-' + question.id);
      style.setAttribute('type', 'text/css');
      style.innerHTML = question.css.replace(/{this}/g, '#question-' + question.id);
      head.appendChild(style);
    }

    question.javascripts.map(javascript => {
      if(javascript.action === 'componentDidMount'){
        let func = new Function("return " + "function () { " + javascript.code + " }")().bind(this);
        func();
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    const {question} = this.props;
    let style = document.getElementById('question-style-' + question.id);
    if(style){
      style.parentNode.removeChild(style);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(_.isUndefined(nextProps.questionResponse)){
      const microTime = getCurrentMicroTime(this.props.startTime);
      this.props.dispatch(updateQuestionResponse({
        question: this.props.question.id,
        details: [],
        microTime,
      }));
    }
  }

  componentDidUpdate(){
    if(!_.isNull(this.state.validate)){
      this.validate();
    }
  }

  questionResponseUpdateDebounced(){
    this.props.onQuestionResponseUpdate();
  }

  handleExcludingChanged(excludingSelected, excludingMicroTime){
    const {question, questionResponse} = this.props;
    const excluding = parseInt(questionResponse.excluding) === excludingSelected ? null : excludingSelected;

    if(questionResponse.details.length > 0){
      this.setState({
        handledDetails: questionResponse.details
      });
    }

    this.dispatchQuestionResponse({
      question: question.id,
      excluding,
      excludingMicroTime,
      details: excluding ? [] : this.state.handledDetails,
    }).then(() => {
      if(this.props.question.isAffectsOtherQuestionsOnSamePage){
        this.questionResponseUpdateDebounced();
      }
    });
  }

  handleDetailsUpdated(details){
    return this.dispatchQuestionResponse({
      ...this.props.questionResponse,
      question: this.props.question.id,
      details
    }).then(() => {
      if(this.props.question.isAffectsOtherQuestionsOnSamePage){
        this.questionResponseUpdateDebounced();
      }
    });
  }

  handleFileUpload(filePath) {
    return this.dispatchQuestionResponse({
      ...this.props.questionResponse,
      question: this.props.question.id,
      filePath
    })
  }

  dispatchQuestionResponse(data) {
    const {microTime} = this.props.questionResponse;

    return new Promise((resolve) => {
      this.props.dispatch(updateQuestionResponse({
        ...data,
        microTime
      }));
      resolve();
    });
  }

  getAnswerArea() {
    const {question, questionResponse, changePage, isLastOnPage, intl, surveyNav} = this.props;
    const {validate} = this.state;

    const defaultProps = {
      id: question.id,
      ref: this.questionAnswerArea,
      questionResponse,
      details: questionResponse.details || [],
      onDetailsUpdated: this.handleDetailsUpdated,
      validationTexts: question.validationTexts,
      validate: surveyNav.hideValidation ? null : validate,
      changePage,
      question,
      isLastOnPage,
      intl,
    };

    switch (question.type) {
      case 'single':
        return <Single {...defaultProps} />;
      case 'matrix':
        return <Matrix {...defaultProps} />;
      case 'multi':
        return <Multi {...defaultProps} />;
      case 'multiOpen':
        return <MultiOpen {...defaultProps} />;
      case 'open':
        return <Open {...defaultProps} />;
      case 'ranked':
        return <Ranked {...defaultProps} />;
      case 'conjoint':
        return <Conjoint {...defaultProps} />;
      case 'video':
        return <Video {...defaultProps} />;
      case 'matrixMulti':
        return <MatrixMulti {...defaultProps} />;
      case 'matrixDropdown':
        return <MatrixDropdown {...defaultProps} />;
      case 'numericMulti':
        return <NumericMulti {...defaultProps} />;
      case 'numeric':
        return <Numeric {...defaultProps} />;
      case 'basket':
        return <Basket {...defaultProps} />;
      case 'gMap':
        return <GMap {...defaultProps} />;
      case 'nps':
        return <Nps {...defaultProps} />;
      case 'maxDiff':
        return <MaxDiff {...defaultProps} />;
      case 'differential':
        return <Differential {...defaultProps} />;
      case 'comment':
        return <Comment {...defaultProps} />;
      case 'bpto':
        return <Bpto {...defaultProps} />;
    }
  }

  validate(){
    const {questionResponse, question} = this.props;
    if(!this.questionAnswerArea.current){
      return false;
    }

    const validate = this.questionAnswerArea.current.validate();

    if(validate.valid === false && !this.isMobile() && !_.isEmpty(question.validationText)){
      validate.errors = [question.validationText];
    }
    if(validate.valid === false && this.isMobile() && (!_.isEmpty(question.validationTextMobile) || !_.isEmpty(question.validationText))){
      if(!_.isEmpty(question.validationTextMobile)){
        validate.errors = [question.validationTextMobile];
      }else if(!_.isEmpty(question.validationText)){
        validate.errors = [question.validationText];
      }
    }

    if (this.fileUploader.current) {
      if (this.fileUploader.current.state.loading) {
        validate.errors.push("Trwa przesyłanie pliku");
        validate.valid = false;
      }

      if (this.fileUploader.current.state.file && !this.fileUploader.current.state.loaded) {
        validate.errors.push("Prześlij lub usuń wybrany plik");
        validate.valid = false;
      }
    }

    if(questionResponse.excluding){
      const validateQuestion = {
        valid: true,
        errors: []
      };
      if(!this.state.validate || validateQuestion.valid !== this.state.validate.valid) {
        this.setState({
          validate: validateQuestion
        });
      }

      return validateQuestion;
    }

    if(!_.isEqual(validate, this.state.validate)){
      this.setState({
        validate
      });
    }

    return validate;
  }

  getValidation() {
    const {question, page} = this.props;
    const {validate} = this.state;

    if (page.validate && page.validate[question.id]) {
      return page.validate[question.id];
    }

    return validate;
  }

  render() {
    const {question, startTime, questionResponse, surveyNav, page} = this.props;
    const {validate} = this.state;
    const validation = this.getValidation();

    if(!questionResponse){
      return false;
    }

    return (
      <Card style={{ zIndex: (99999-question.position) }} id={'question-' + question.id} className={classnames({
        'show-vertically': question.showVertically,
        'has-instruction': question.instructionDisplay || question.instructionDisplayMobile || (!surveyNav.hideValidation && !_.isNull(validation) && validation.errors.length > 0),
        'validation-errors-exist': (!surveyNav.hideValidation && !_.isNull(validation) && validation.errors.length > 0)
      }) + " question " + question.type + " " + question.presentationType}
      >
        <CardHeader>
          <CardTitle className={"ck-content"}>{question.content ? <div dangerouslySetInnerHTML={{__html: question.content}} /> : <FormattedMessage id="question.noContent" tagName='i'/>}</CardTitle>
        </CardHeader>
        {(question.instructionDisplay && !this.isMobile()) && <Alert className="instruction mb-0" color="">{question.instructionDisplay}</Alert>}
        {(question.instructionDisplayMobile && this.isMobile()) && <Alert className="instruction mb-0" color="">{question.instructionDisplayMobile}</Alert>}

        {!surveyNav.hideValidation &&  (!_.isNull(validation) && validation.errors.length > 0) && <Alert className="validation-errors mb-0">{validation.errors.map((error, key) => <span key={key} className="d-block w-100">{error}</span>)}</Alert>}

        {question.fileUpload && <FileUpload question={question} response={questionResponse} ref={this.fileUploader} handleUpdate={this.handleFileUpload}/>}

        <CardBody className={classnames({
          'ck-content': true,
          'answer-area': true,
          'excluding-overlay': !!questionResponse.excluding
        })}>
          {this.getAnswerArea()}
        </CardBody>

        {question.excludings.length > 0 && <Excludings
          question={question}
          excludings={question.excludings}
          selected={parseInt(questionResponse.excluding) || 0}
          onExcludingChanged={this.handleExcludingChanged}
          startTime={startTime}
        />}
      </Card>
    )
  }
}

Question.propTypes = {
  onQuestionResponseUpdate: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string,
    type: PropTypes.string.isRequired,
    excludings: PropTypes.array.isRequired,
    instructionDisplay: PropTypes.string,
    isAffectsOtherQuestionsOnSamePage: PropTypes.bool,
    validationTexts: PropTypes.object.isRequired,
    fileUpload: PropTypes.bool.isRequired,
    css: PropTypes.string,
    javascripts: PropTypes.array.isRequired,
    questionResponse: PropTypes.shape({
      question: PropTypes.number.isRequired,
      details: PropTypes.arrayOf(PropTypes.shape({
        microTime: PropTypes.number,
      }),),
      microTime: PropTypes.number.isRequired,
    })
  }).isRequired,
  isLastOnPage: PropTypes.bool.isRequired,
  questionResponse: PropTypes.oneOfType([
    PropTypes.shape({
      question: PropTypes.number.isRequired,
      details: PropTypes.arrayOf(PropTypes.shape({
        microTime: PropTypes.number,
      }),),
      microTime: PropTypes.number.isRequired,
    }).isRequired,
    PropTypes.bool.isRequired,
  ]),
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state, props){
  return {
    page: state.page,
    surveyNav: state.surveyNav,
    startTime: state.timeMeasuring.startTime,
    surveyResponse: state.surveyResponse,
    questionResponse: _.find(state.questionResponses, questionResponse => questionResponse.question === props.question.id),
  }
}

export default connect(mapStateToProps, null, null, {withRef: true, forwardRef: true})(Question);
